module.exports = "<h3 [innerHTML]=\"matchedItem.question | safeHtml\">\n</h3>\n<div class=\"content\">\n    <div [innerHTML]=\"matchedItem.answer | safeHtml\"></div>\n    <div class=\"btn btn-link active\" (click)=\"scrollToCategoryItem()\"> - Lire la suite</div>\n</div>\n<div class=\"highlight-item-seperator\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/faq/faq-search/faq-highlight/faq-highlight.component.html
// module id = 798
// module chunks = 0